const sectionLabel: React.CSSProperties = {
  fontSize: '0.5625rem',
  fontWeight: 700,
  color: '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginTop: '0.5rem',
};

export default function BehaviourCardMock() {
  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" style={{ background: '#f59e0b' }} /> Behaviour</div>
      <div className="platform-mock-body" style={{ padding: '1rem 1.25rem' }}>
        <div style={{ fontSize: '1rem', fontWeight: 700, color: '#e5e7eb', marginBottom: '0.25rem' }}>
          Mixed Behaviour Profile
        </div>

        <div style={sectionLabel}>Primary Drivers</div>
        <div style={{ fontSize: '0.75rem', color: '#9ca3af', lineHeight: 1.6 }}>
          Edge driven by asymmetry, not accuracy<br />
          Experiences extended losing streaks
        </div>

        <div style={sectionLabel}>Observed Conditions</div>
        <div style={{ fontSize: '0.75rem', color: '#9ca3af', lineHeight: 1.6 }}>
          Low win rate persists; outcomes rely on payoff asymmetry<br />
          Significant drawdowns during adverse periods
        </div>

        <div style={{
          marginTop: 'auto',
          paddingTop: '0.75rem',
          fontSize: '0.6875rem',
          color: '#6b7280',
          fontStyle: 'italic',
        }}>
          Consistency: <span style={{ color: '#e5e7eb', fontWeight: 600, fontStyle: 'normal' }}>Regime-dependent behaviour</span>
        </div>
      </div>
      <div className="platform-mock-caption">
        The Behaviour card classifies the strategy's profile and explains what drove the results.
      </div>
    </div>
  );
}
